
import ApiURL from "../../api/ApiURL";
import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import ImagePopup from "./ImagePopup";

const destinationData = [
    {
        ImageName: "4nights-5days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "5nights-6days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "6nights-7days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "7nights-8days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "8nights-9days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "9nights-10days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "10nights-11days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "11nights-12days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "12nights-13days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through <a href='https://adorablevacation.com/bhutan-tour-package-from-surat/' target='_blank'>Bhutan Package Tour From Surat</a>, Pelling, and Darjeeling.",
        BookNowURL: "/",
    },
    
];


// ---------------second part data insert
const destinationData2 = [
    {
        ImageName: "4nights-5days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: " Mumbai Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "5nights-6days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "6nights-7days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "7nights-8days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "8nights-9days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "9nights-10days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "10nights-11days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "11nights-12days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through Gangtok, Pelling, and Darjeeling. These three incredibly beautiful destinations.",
        BookNowURL: "/",
    },
    {
        ImageName: "12nights-13days-bhutan-tour-package-Adorable-Vacation-Bhutan.webp",
        AlternateText: "Image of Bhutan",
        Title: "Bhutan",
        Description: "Get ready for a whirlwind journey through <a href='https://adorablevacation.com/bhutan-tour-package-from-surat/' target='_blank'>Bhutan Package Tour From Surat</a>, Pelling, and Darjeeling.",
        BookNowURL: "/",
    },
    
];
function GalleryExplorerInside() {
    const imageUrls = destinationData.map(
        (item) => `${ApiURL.GalleryExplorerInsideImageURL}/${item.ImageName}`
    );
    return (
        <div className="container-fluid custom-container2">
            <article>
            <div className="row">
                <div className="col-md-12">
                    <div className="site-heading text-center">
                        <h1>
                            Bhutan <span>Explorer</span>
                        </h1>
                        <h4>Our Valuable Tour</h4>
                    </div>
                </div>
               
                <div className="col-md-12 p-3">
                    <h2><center><b>ROTARY CLUB OF BOMBAY BAYVIEW</b></center></h2>
                    <p><center>Discover the mystical kingdom of Bhutan with our all-inclusive Bhutan Package Tour. Nestled in the Himalayas, Bhutan offers a perfect blend of scenic beauty, rich culture,</center></p>
                </div>
            </div>

            <div className="row gallery-grid custom-containergallery">
            {destinationData.map((item, index) => {
                    const sliderImageURL = `${ApiURL.GalleryExplorerInsideImageURL}/${item.ImageName}`;
                    return (
                        <div className="cards-wrapper2 py-5" key={index}>
                            <div className="card">
                                <div className="image-wrapper2">
                                <ImagePopup
                                    index={index} 
                                    images={imageUrls} 
                                    sliderImageURL={sliderImageURL} 
                                    alternateText={item.AlternateText}
                                />
                                </div>
                                  <p className="card-text decorated-text" dangerouslySetInnerHTML={{ __html: item.Description }}></p>
                            </div>
                        </div>
                       
                    );
                })}
            </div>
            </article>
{/* ----------------------------second section---------------------------------- */}
            <article>
            <div className="row py-5">
                <div className="col-md-12">
                    <div className="site-heading text-center">
                        <h1>
                            Bhutan <span>Explorer</span>
                        </h1>
                        <h4>Our Valuable Tour</h4>
                    </div>
                </div>
               
                <div className="col-md-12 p-3">
                    <h2><center><b>Bhutan Group Tour From Mumbai - Rotary PR Group</b></center></h2>
                    <p><center>Discover the mystical kingdom of Bhutan with our all-inclusive Bhutan Package Tour. Nestled in the Himalayas, Bhutan offers a perfect blend of scenic beauty, rich culture,</center></p>
                </div>
            </div>

            <div className="row gallery-grid custom-containergallery">
            {destinationData2.map((item, index) => {
                    const sliderImageURL = `${ApiURL.GalleryExplorerInsideImageURL}/${item.ImageName}`;
                    return (
                        <div className="cards-wrapper2" key={index}>
                            <div className="card">
                                <div className="image-wrapper2">
                                <ImagePopup
                                    index={index} 
                                    images={imageUrls} 
                                    sliderImageURL={sliderImageURL} 
                                    alternateText={item.AlternateText}
                                />
                                </div>
                                  <p className="card-text decorated-text" dangerouslySetInnerHTML={{ __html: item.Description }}></p>
                            </div>
                        </div>
                       
                    );
                })}
            </div>
            </article>
        </div>
        
    );
};

export default GalleryExplorerInside;

